// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__WD-9e","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1Ufre","obliqueLine":"membershipbadge_obliqueLine__3oQYr"};